import { Typography, Box } from "@mui/material";
import backgroundImage from "../../../shared/asserts/background_general.png";
import { CustomArrowTitle } from "./custom-arrow-title";

export const GeneralInfo = () => {
  return (
    <Box
      sx={{
        margin: "0 auto",
        padding: 2,
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: "center right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "332px auto",
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
        Welcome to Conversational AI!
      </Typography>
      <Typography variant="subtitle1" paragraph align="center">
        Unlock the Power of Your Data. Just ask naturally, and let the AI handle
        the rest.
      </Typography>
      <CustomArrowTitle text={"What Can You Do Here?"} />
      <Box sx={{ ml: 4 }}>
        <Typography variant="body1" paragraph>
          This chatbot answers questions about:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1" fontWeight="bold">
              Reservations
            </Typography>
          </li>
          <li>
            <Typography variant="body1" fontWeight="bold">
              Folio Invoices
            </Typography>
          </li>
          <li>
            <Typography variant="body1" fontWeight="bold">
              Profiles
            </Typography>
          </li>
        </ul>

        <Typography variant="body1" paragraph>
          Examples:
        </Typography>
        <Box sx={{ ml: 4 }}>
          <Typography variant="body1">
            📊 "Show me reservations from last month."
          </Typography>
          <Typography variant="body1">
            🔎 "How many were confirmed last month?"
          </Typography>
          <Typography variant="body1">
            🏨 "What's the most popular room type?"
          </Typography>
        </Box>
      </Box>

      <CustomArrowTitle text={"Why Conversational AI?"} />
      <ul>
        <li>
          <Typography variant="body1">
            <b>Simplicity</b>: Ask in plain language.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <b>Efficiency</b>: Instant insights.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <b>Clarity</b>: Easily understand your data.
          </Typography>
        </li>
      </ul>
      <CustomArrowTitle text={"How to Get Started?"} />
      <Typography variant="body1">
        Ask below, explore suggestions, and view results.
      </Typography>
    </Box>
  );
};
